class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onDetailsToggle = this.onDetailsToggle.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Add handler for automatically closing other filters
    this.addEventListener('toggle', this.onDetailsToggle, true);
    
    // Also add handler for mobile filters
    const mobileFacetsForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileFacetsForm) {
      mobileFacetsForm.addEventListener('toggle', this.onDetailsToggle, true);
    }

    // Add click outside handler to close filters
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
        setTimeout(() => {
          if (typeof restoreCollectionView === 'function') {
            console.log('Calling restoreCollectionView after filter update...');
            restoreCollectionView();
          }
        }, 0);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
    setTimeout(() => {
      if (typeof restoreCollectionView === 'function') {
        console.log('Calling restoreCollectionView after cache update...');
        restoreCollectionView();
      }
    }, 0);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onDetailsToggle(event) {
    // Check that the event occurred on a details element and it's opening
    if (event.target.tagName === 'DETAILS' && event.target.open) {
      // Find all other details elements with js-filter class in the document
      const allDetails = document.querySelectorAll('details.js-filter');
      
      // Close all except the current one
      allDetails.forEach(details => {
        if (details !== event.target) {
          details.open = false;
        }
      });
      
      // Close sort dropdown when opening filters
      const sortSelect = document.querySelector('.select-unique');
      if (sortSelect && !sortSelect.classList.contains('opacity-0')) {
        sortSelect.classList.add('opacity-0');
      }
      
      // Close currency dropdown when opening filters
      const currencyDropdown = document.querySelector('.currency-drop-down');
      if (currencyDropdown && currencyDropdown.classList.contains('currency-drop-down--is-open')) {
        currencyDropdown.classList.remove('currency-drop-down--is-open');
        const currencyMenu = document.querySelector('.currency-drop-down__menu');
        if (currencyMenu) {
          currencyMenu.style.display = 'none';
        }
      }
    }
  }

  onDocumentClick(event) {
    // Check if click is outside filter areas
    const clickedElement = event.target;
    
    // Check if click is outside filter areas
    const isOutsideFilters = !clickedElement.closest('#FacetsWrapperDesktop') && 
                            !clickedElement.closest('.mobile-facets__wrapper') &&
                            !clickedElement.closest('.select-unique') &&
                            !clickedElement.closest('.facet-filters__label') &&
                            !clickedElement.closest('.facet-filters__field') &&
                            !clickedElement.closest('.currency-drop-down');
    
    if (isOutsideFilters) {
      // Close all filters by adding opacity-0 class
      const allDetails = document.querySelectorAll('details.js-filter');
      allDetails.forEach(details => {
        details.classList.add('opacity-0');
      });
      
      // Close sort dropdown if open
      const sortSelect = document.querySelector('.select-unique');
      if (sortSelect && !sortSelect.classList.contains('opacity-0')) {
        sortSelect.classList.add('opacity-0');
      }
      
      // Close currency dropdown if open
      const currencyDropdown = document.querySelector('.currency-drop-down');
      if (currencyDropdown && currencyDropdown.classList.contains('currency-drop-down--is-open')) {
        currencyDropdown.classList.remove('currency-drop-down--is-open');
        const currencyMenu = document.querySelector('.currency-drop-down__menu');
        if (currencyMenu) {
          currencyMenu.style.display = 'none';
        }
      }
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Global handler for automatically closing filters
document.addEventListener('toggle', function(event) {
  // Check that the event occurred on a details element with js-filter class and it's opening
  if (event.target.tagName === 'DETAILS' && 
      event.target.classList.contains('js-filter') && 
      event.target.open) {
    
    // Find all other details elements with js-filter class
    const allDetails = document.querySelectorAll('details.js-filter');
    
    // Close all except the current one
    allDetails.forEach(details => {
      if (details !== event.target) {
        details.open = false;
      }
    });
    
    // Close sort dropdown when opening filters
    const sortSelect = document.querySelector('.select-unique');
    if (sortSelect && !sortSelect.classList.contains('opacity-0')) {
      sortSelect.classList.add('opacity-0');
    }
    
    // Close currency dropdown when opening filters
    const currencyDropdown = document.querySelector('.currency-drop-down');
    if (currencyDropdown && currencyDropdown.classList.contains('currency-drop-down--is-open')) {
      currencyDropdown.classList.remove('currency-drop-down--is-open');
      const currencyMenu = document.querySelector('.currency-drop-down__menu');
      if (currencyMenu) {
        currencyMenu.style.display = 'none';
      }
    }
  }
}, true);

// Global click outside handler
document.addEventListener('click', function(event) {
  // Check if click is outside filter areas
  const clickedElement = event.target;
  
  const isOutsideFilters = !clickedElement.closest('#FacetsWrapperDesktop') && 
                          !clickedElement.closest('.mobile-facets__wrapper') &&
                          !clickedElement.closest('.select-unique') &&
                          !clickedElement.closest('.facet-filters__label') &&
                          !clickedElement.closest('.facet-filters__field') &&
                          !clickedElement.closest('.currency-drop-down');
  
  if (isOutsideFilters) {
    // Close all filters by adding opacity-0 class
    const allDetails = document.querySelectorAll('details.js-filter');
    allDetails.forEach(details => {
      details.classList.add('opacity-0');
    });
    
    // Close sort dropdown if open
    const sortSelect = document.querySelector('.select-unique');
    if (sortSelect && !sortSelect.classList.contains('opacity-0')) {
      sortSelect.classList.add('opacity-0');
    }
    
    // Close currency dropdown if open
    const currencyDropdown = document.querySelector('.currency-drop-down');
    if (currencyDropdown && currencyDropdown.classList.contains('currency-drop-down--is-open')) {
      currencyDropdown.classList.remove('currency-drop-down--is-open');
      const currencyMenu = document.querySelector('.currency-drop-down__menu');
      if (currencyMenu) {
        currencyMenu.style.display = 'none';
      }
    }
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
